 export const Language = {
    FR : "fr",
    EN : "en",
}